import { useRef } from "react";

export default function LikeAndDislike({ like, dislike, pos }) {
  const timeoutRef = useRef(null);
  const timeout = () => {
    timeoutRef.current = setTimeout(() => {
      like.reset();
      dislike.reset();
    }, 3000);
  };

  const Messages = () => {
    const req = [like, dislike];
    const res = req.find((state) => state && (state.isError || state.isSuccess || state.isLoading));
    if (res.isError || res.isSuccess) timeout();
    console.log(res.status, "dadaad");

    return (
      <p
        style={{ margin: 0 }}
        className={`${pos} left-0 ${
          res?.isError ? "err" : res?.isSuccess ? "succ" : "prime"
        }-bg-c p-15 absolute index-15 full-w transform-origan-center`}>
        {res.isError &&
          (res?.error?.status === 409
            ? "You have already voted."
            : "An unexpected error occurred. Please try again later.")}
        {res.isSuccess && "thanks for your vote"}
        {res?.isLoading && "loading...."}
      </p>
    );
  };

  const isThereAMessage = [like, dislike].some((status) => !status?.isIdle);

  return isThereAMessage ? <Messages /> : null;
}
